exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-subject-wrapper[data-v-ae2e21f0]{border:1px solid #ddd}.questionnaire-overview .questionnaire-title[data-v-ae2e21f0]{font-size:16px}.questionnaire-footer[data-v-ae2e21f0]{padding:0 12px 16px}.questionnaire-footer .review[data-v-ae2e21f0]{justify-content:flex-end}.modal-title[data-v-ae2e21f0]{border-bottom:1px solid #e5e5e5}.modal-content[data-v-ae2e21f0]{margin-top:30px}", ""]);

// exports
